export type DisplayMode = 'credits' | 'euros';

/** 1€ = 1000 credits → 1 credit = 0.001€ */
export const MVP_CONVERSION_RATE = 0.001;
